import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSidebarCollapsed, toggleSidebar } from "../features/ui/uiSlice";
import { T } from "../shared/theme";
import { ICONS } from "../shared/icons";
import NavSections from "./NavSections";
import "./Sidebar.css";

/**
 * Десктопный сайдбар — Soft Slate (AUFB-67).
 *
 * Стили вынесены в Sidebar.css: раньше здесь было ~180 строк инлайновых
 * объектов, из-за чего сайдбар нельзя было адаптировать медиазапросами.
 * Секции живут в NavSections — тот же компонент используется мобильным
 * drawer'ом.
 *
 * Блок пользователя и выход переехали в AppHeader: при 22 пунктах меню
 * подвал отнимал высоту у навигации и упирался в список.
 */
export function Sidebar() {
  const dispatch = useDispatch();
  const collapsed = useSelector(selectSidebarCollapsed);

  const width = collapsed ? T.sidebarCollapsedW : T.sidebarW;

  return (
    <aside
      className={`app-sidebar${collapsed ? " is-collapsed" : ""}`}
      style={{ width }}
    >
      <div className="logo">
        {collapsed ? (
          <div className="logo-icon" title="AUF CRM">
            AUF
          </div>
        ) : (
          <div className="logo-full">
            <span className="logo-auf">AUF</span>
            <span className="logo-crm">CRM</span>
          </div>
        )}
        <button
          type="button"
          onClick={() => dispatch(toggleSidebar())}
          className={`collapse-btn${collapsed ? "" : " is-expanded"}`}
          style={{ marginLeft: collapsed ? 0 : "auto" }}
          title={collapsed ? "Развернуть меню" : "Свернуть меню"}
          aria-label={collapsed ? "Развернуть меню" : "Свернуть меню"}
        >
          {ICONS.chevron}
        </button>
      </div>

      <NavSections collapsed={collapsed} />
    </aside>
  );
}

export default Sidebar;
